export default "__VITE_ASSET__C2_DKr8B__"